import './App.css';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import PageNotFound from './pages/PageNotFound.jsx';
import LoginPage from './pages/LoginPage.jsx';
import WelcomePage from './pages/WelcomePage.jsx';
import WelcomeTrialPage from './pages/WelcomeTrialPage.jsx';
import SignupPage from './pages/SignupPage.jsx';
import VerificationSentPage from './pages/VerificationSentPage.jsx'
import VerifiedPage from './pages/VerifiedPage.jsx'
import SetPasswordPage from './pages/SetPasswordPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import LibraryPage from './pages/LibraryPage';
import CityAttractionsPage from './pages/CityAttractionsPage';
import SeoPage from './pages/SeoPage';
import SuccessPage from './pages/SuccessPage';
import FailurePage from './pages/FailurePage';
import SubscriptionPage from './pages/SubscriptionPage';
import TourPaymentPage from './pages/TourPaymentPage';
import StoryCreationPage from './pages/StoryCreationPage';
import StoryVideoGenerationPage from './pages/StoryVideoGenerationPage';
import TourLibraryPage from './pages/TourLibraryPage';
import PromptsPage from './pages/PromptsPage';
import VideoToUrlPage from './pages/VideoToUrlPage';
import VideoWithLinkPage from './pages/VideoWithLinkPage';
import ScrapePage from './pages/ScrapePage';
import AgreementsPage from './pages/AgreementsPage';

function App() {
  return (
    <Router>
      <Switch>
      <Route path="/videowithlink/:id" component={VideoWithLinkPage} />
      <Route path="/scrape" component={ScrapePage} />
      <Route path="/agreements" component={AgreementsPage} />
      <Route path="/prompts" component={PromptsPage} />
      <Route path="/videotourl" component={VideoToUrlPage} />
      <Route path="/tourlibrary" component={TourLibraryPage} />
      <Route path="/storycreation" component={StoryCreationPage} />
      <Route path="/storyvideogeneration" component={StoryVideoGenerationPage} />
      <Route path="/tourpayment/:tourid" component={TourPaymentPage} />
      <Route path="/subscription/:subscription" component={SubscriptionPage} />
      <Route path="/amadeus" component={CityAttractionsPage} />
      <Route path="/seo" component={SeoPage} />
      <Route path="/success" component={SuccessPage} />
      <Route path="/failure" component={FailurePage} />
      <Route path="/verificationsent" component={VerificationSentPage} />
      <Route path="/verified/:email" component={VerifiedPage} />
        <Route path="/setPassword/:email" component={SetPasswordPage} />
      <Route path="/forgotPassword" component={ForgotPasswordPage} />
        <Route path="/404" component={PageNotFound} />
        <Route path="/login" component={LoginPage} />
      <Route path="/trial" component={WelcomeTrialPage} />
      <Route path="/library" component={LibraryPage} />
        <Route path="/signup" component={SignupPage} />
      <Route path="/" component={WelcomePage} />
        <Redirect to="/404" />
      </Switch>
    </Router>
  );
}

export default App;
